export default {
  allMsg: 'Todos los mensajes',
  systemMsg: 'Mensajes del sistema',
  personMsg: 'Mensajes manuales',
  unread: 'No leído',
  seeDetail: 'Ver detalles',
  read: 'Leído',
  replyNow: 'Responder ahora',
  message: 'Mensaje',
  operateSuccess: 'Operación realizada con éxito',
  holder: {
    searchHolder: 'Número de paquete/Número de pedido/Número de artículo',
  },
  addAcBuy: '¡Únete al Discord de AcBuy y gana ¥2000 en efectivo! ',
  joinNow: 'Únete aquí',
  flatActivity: 'Comparte cómo compras en Taobao y AcBuy — ¡Gana ¥1500 en efectivo!',
  joinNow1: 'Únete ahora',
  tips1: 'Sorteo oficial de Labubu de Acbuy',
  tips2: '¡Gran sorteo de Labubu y set completo de ZIMOMO',
}
